/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeviceDetail } from './DeviceDetail';
import {
    DeviceDetailFromJSON,
    DeviceDetailFromJSONTyped,
    DeviceDetailToJSON,
    DeviceDetailToJSONTyped,
} from './DeviceDetail';

/**
 * 
 * @export
 * @interface GetDevicesResponse
 */
export interface GetDevicesResponse {
    /**
     * 
     */
    devices: Array<DeviceDetail>;
}

/**
 * Check if a given object implements the GetDevicesResponse interface.
 */
export function instanceOfGetDevicesResponse(value: object): value is GetDevicesResponse {
    if (!('devices' in value) || value['devices'] === undefined) return false;
    return true;
}

export function GetDevicesResponseFromJSON(json: any): GetDevicesResponse {
    return GetDevicesResponseFromJSONTyped(json, false);
}

export function GetDevicesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDevicesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'devices': ((json['devices'] as Array<any>).map(DeviceDetailFromJSON)),
    };
}

export function GetDevicesResponseToJSON(json: any): GetDevicesResponse {
    return GetDevicesResponseToJSONTyped(json, false);
}

export function GetDevicesResponseToJSONTyped(value?: GetDevicesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'devices': ((value['devices'] as Array<any>).map(DeviceDetailToJSON)),
    };
}

